/* eslint-disable compat/compat */

import { ResizeObserver as Polyfill } from 'https://esm.archive.org/@juggle/resize-observer@^3.3.1';

const ResizeObserver = window.ResizeObserver || Polyfill;
window.ResizeObserver = ResizeObserver;
